import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import HowItWorks from "@/pages/HowItWorks";
import ISOPartners from "@/pages/ISOPartners";
import FundingSolutions from "@/pages/FundingSolutions";
import Contact from "@/pages/Contact";
import Lenders from "@/pages/Lenders";
import Signatures from "@/pages/Signatures";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Admin from "@/pages/Admin";
import Apply from "@/pages/Apply";

function App() {
    return (
        <BrowserRouter>
            <Layout>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/how-it-works" element={<HowItWorks />} />
                    <Route path="/iso-partners" element={<ISOPartners />} />
                    <Route path="/funding" element={<FundingSolutions />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/lenders" element={<Lenders />} />
                    <Route path="/signatures" element={<Signatures />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/apply" element={<Apply />} />
                </Routes>
            </Layout>
        </BrowserRouter>
    );
}

export default App;
